/**
 * Extract the date portion of the given dateTimeString
 * Example:
 * >> extractDateFromDateTimeString("Sabtu, 22 Mei 2021 21.06")
 * "Sabtu, 22 Mei 2021"
 * @param {string} dateTimeString
 */

export function extractDateFromDateTimeString(dateTimeString) {
  let dateString = dateTimeString.replace(/[0-9]{2}(:|\.)[0-9]{2}/, ""); // remove the time portion
  dateString = dateString.replace(new RegExp("(,|\\s)+$"), "");
  return dateString;
}

/**
 * Generate the public sharable itinerary URL from an itinerary
 *
 * @param {string} username
 * @param {string} itinId
 * @returns {string}
 */
export function generateShareItinUrl(username, itinId) {
  return `${window.location.origin}/itin/share/${username}/${itinId}`;
}
